import { render, staticRenderFns } from "./puntuation.vue?vue&type=template&id=d7178272&"
import script from "./puntuation.vue?vue&type=script&lang=js&"
export * from "./puntuation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports